import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

export default function Noticias() {
  const { t } = useTranslation();
  const [news, setNews] = useState([]);
  const [expanded, setExpanded] = useState({});

  useEffect(() => { axios.get("/api/news").then(r => setNews(r.data || [])).catch(() => {}); }, []);

  const toggle = (id) => {
    setExpanded(prev => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section className="section-light py-12" data-testid="news-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="mb-8">
          <div className="divider-red mb-4"></div>
          <h1 className="font-display text-4xl sm:text-5xl">{t("noticias.titulo")}</h1>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {news.map(n => (
            <article key={n.id} className="bg-black text-white rounded-lg overflow-hidden border border-neutral-800" data-testid={`news-${n.id}`}>
              <div className="aspect-[16/10] bg-neutral-800 overflow-hidden">
                {n.imagen_url && <img src={n.imagen_url} alt={n.titulo} className="w-full h-full object-cover" />}
              </div>
              <div className="p-5">
                <h2 className="font-display text-xl leading-tight mb-3">{n.titulo}</h2>
                <p className={`text-sm text-neutral-300 leading-relaxed mb-4 ${expanded[n.id] ? "" : "line-clamp-4"}`}>
                  {n.contenido}
                </p>
                <button
                  className="btn-red px-4 py-2 text-sm"
                  data-testid={`news-read-${n.id}`}
                  onClick={() => toggle(n.id)}
                >
                  {expanded[n.id] ? t("noticias.leerMenos") : t("noticias.leerMas")}
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
